(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const body = document.body;
  const overlay = qs('[data-overlay]');
  const menu = qs('#MobileMenu');
  const cartDrawer = qs('#CartDrawer');
  const cartContent = qs('[data-cart-content]');

  const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
    style: 'currency', currency: window.ElvenicTheme?.currency || 'USD'
  }).format((Number(cents) || 0) / 100);
  const reconvertPrices = () => requestAnimationFrame(() => {
    window.bucksCC?.reConvert?.();
  });

  const closeDrawers = () => {
    menu?.classList.remove('open'); cartDrawer?.classList.remove('open'); overlay?.classList.remove('show');
    menu?.setAttribute('aria-hidden', 'true'); cartDrawer?.setAttribute('aria-hidden', 'true');
    qs('.menu-button')?.setAttribute('aria-expanded', 'false'); body.style.overflow = '';
  };
  const openDrawer = (drawer) => {
    closeDrawers(); drawer?.classList.add('open'); drawer?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('show'); body.style.overflow = 'hidden';
  };

  qs('.menu-button')?.addEventListener('click', () => { openDrawer(menu); qs('.menu-button')?.setAttribute('aria-expanded', 'true'); });
  qs('[data-close-menu]')?.addEventListener('click', closeDrawers);
  qs('[data-close-cart]')?.addEventListener('click', closeDrawers);
  overlay?.addEventListener('click', closeDrawers);
  qsa('#MobileMenu a').forEach((link) => link.addEventListener('click', closeDrawers));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawers(); });

  const updateCartCount = (count) => qsa('[data-cart-count]').forEach((node) => {
    node.textContent = count; node.hidden = count === 0;
  });

  const renderCart = (cart) => {
    updateCartCount(cart.item_count);
    if (!cartContent) return;
    if (!cart.items.length) {
      cartContent.innerHTML = '<div class="empty-cart"><strong>Your cart is empty.</strong><p>Choose a pack to add Elvenic Pulse.</p><button class="primary-button" type="button" data-continue-shopping>Continue shopping</button></div>';
      qs('[data-continue-shopping]', cartContent)?.addEventListener('click', closeDrawers);
      return;
    }
    cartContent.innerHTML = `<div class="drawer-items">${cart.items.map((item, index) => `
      <article class="drawer-item">
        ${item.image ? `<img src="${item.image}" alt="">` : ''}
        <div>
          <strong>${item.product_title}</strong>
          <span class="money">${formatMoney(item.final_line_price)}</span>
          <div class="drawer-quantity" aria-label="Quantity for ${item.product_title}">
            <span>Quantity</span>
            <button type="button" data-quantity-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease ${item.product_title} quantity">−</button>
            <b aria-live="polite">${item.quantity}</b>
            <button type="button" data-quantity-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase ${item.product_title} quantity">+</button>
          </div>
          <button type="button" data-remove-line="${index + 1}">Remove</button>
        </div>
      </article>`).join('')}</div>
      <div class="cart-total"><span>Subtotal</span><strong class="money">${formatMoney(cart.total_price)}</strong></div>
      <a class="primary-button" href="/checkout">Checkout securely</a>`;
    qsa('[data-remove-line]', cartContent).forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.removeLine), quantity: 0 }) });
      await refreshCart();
    }));
    qsa('[data-quantity-change]', cartContent).forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(button.dataset.line), quantity: Number(button.dataset.quantity) })
      });
      await refreshCart();
    }));
    reconvertPrices();
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json(); renderCart(cart); return cart;
  };
  qs('.cart-button')?.addEventListener('click', async () => {
    openDrawer(cartDrawer);
    try { await refreshCart(); } catch (_) { if (cartContent) cartContent.innerHTML = '<p>Unable to load your cart. Please refresh the page.</p>'; }
  });

  const productRoot = qs('[data-pulse-product]');
  if (productRoot) {
    let selected = qs('[data-pack-option].selected', productRoot) || qs('[data-pack-option]', productRoot);

    const syncSelectedPrice = (option) => {
      if (!option) return;
      const priceSource = qs('.bundle-price b', option);
      const compareSource = qs('.bundle-price del', option);
      const savingSource = qs('.bundle-price em', option);
      const priceHtml = priceSource?.innerHTML || `<span class="money">${formatMoney(option.dataset.price)}</span>`;
      const compareHtml = compareSource?.innerHTML?.replace(/^\s*Value\s*/i, '') || '';
      const savingHtml = savingSource?.innerHTML || '';
      const packName = option.dataset.packName || '';
      const compareMarkup = compareHtml ? `<del>${compareHtml}</del>` : '';
      const savingMarkup = savingHtml ? `<span class="price-savings">${savingHtml}</span>` : '';

      qsa('[data-selected-price]', productRoot).forEach((node, index) => {
        node.innerHTML = `${compareMarkup}<strong>${priceHtml}</strong>${index === 0 ? `<span class="selected-pack-label">· ${packName}</span>` : ''}${savingMarkup}`;
      });
      qsa('[data-sticky-price]').forEach((node) => { node.innerHTML = priceHtml; });
    };

    const updateSelectedPack = (option) => {
      if (!option) return;
      selected = option;
      qsa('[data-pack-option]', productRoot).forEach((item) => item.classList.toggle('selected', item === option));
      const packName = option.dataset.packName || '';
      const available = option.dataset.available === 'true';
      syncSelectedPrice(option);
      qsa('[data-selected-pack]').forEach((node) => { node.textContent = packName; });
      qsa('[data-add-to-cart]').forEach((button) => {
        button.dataset.variantId = option.dataset.variantId || ''; button.disabled = !available;
        button.textContent = available ? (button.closest('.mid-cta,.final-cta') ? 'Get Elvenic Pulse' : 'Add to cart') : 'Sold out';
      });
      reconvertPrices();
    };
    qsa('[data-pack-option]', productRoot).forEach((option) => qs('input', option)?.addEventListener('change', () => updateSelectedPack(option)));
    updateSelectedPack(selected);

    const bundlePrices = qs('.pdp-bundles', productRoot);
    if (bundlePrices) {
      let syncQueued = false;
      new MutationObserver(() => {
        if (syncQueued) return;
        syncQueued = true;
        requestAnimationFrame(() => {
          syncQueued = false;
          syncSelectedPrice(selected);
        });
      }).observe(bundlePrices, { childList: true, characterData: true, subtree: true });
    }

    qsa('[data-add-to-cart]').forEach((button) => button.addEventListener('click', async () => {
      const variantId = button.dataset.variantId || selected?.dataset.variantId;
      if (!variantId) return;
      button.disabled = true; const previousText = button.textContent; button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
        if (!response.ok) throw new Error('Unable to add item');
        await refreshCart(); openDrawer(cartDrawer);
      } catch (_) { button.textContent = 'Please try again'; setTimeout(() => { button.textContent = previousText; button.disabled = false; }, 1800); return; }
      button.textContent = previousText; button.disabled = false;
    }));

    const thumbs = qsa('[data-gallery-thumb]', productRoot);
    const mainImage = qs('[data-gallery-main]', productRoot);
    const counter = qs('[data-gallery-count]', productRoot);
    let galleryIndex = 0;
    const showMedia = (index) => {
      if (!thumbs.length || !mainImage) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[galleryIndex]; mainImage.src = thumb.dataset.src; mainImage.alt = thumb.dataset.alt || '';
      thumbs.forEach((item, itemIndex) => item.classList.toggle('selected', itemIndex === galleryIndex));
      if (counter) counter.textContent = `${galleryIndex + 1} / ${thumbs.length}`;
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
    qs('[data-gallery-previous]', productRoot)?.addEventListener('click', () => showMedia(galleryIndex - 1));
    qs('[data-gallery-next]', productRoot)?.addEventListener('click', () => showMedia(galleryIndex + 1));

    const mobileTrack = qs('[data-mobile-gallery]', productRoot);
    const mobileThumbs = qsa('[data-mobile-thumb]', productRoot);
    mobileThumbs.forEach((thumb) => thumb.addEventListener('click', () => mobileTrack?.scrollTo({ left: Number(thumb.dataset.index) * mobileTrack.clientWidth, behavior: 'smooth' })));
    mobileTrack?.addEventListener('scroll', () => {
      const index = Math.round(mobileTrack.scrollLeft / mobileTrack.clientWidth);
      mobileThumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('selected', index === thumbIndex));
    }, { passive: true });

    const panel = qs('[data-purchase-panel]', productRoot);
    const sticky = qs('[data-sticky-buy]');
    const footer = qs('[data-site-footer]');
    let footerVisible = false;
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; sticky?.classList.toggle('visible', panel?.getBoundingClientRect().bottom <= 0 && !footerVisible); }).observe(footer);
    const updateSticky = () => sticky?.classList.toggle('visible', panel?.getBoundingClientRect().bottom <= 0 && !footerVisible);
    window.addEventListener('scroll', updateSticky, { passive: true }); window.addEventListener('resize', updateSticky); updateSticky();
  }

  refreshCart().catch(() => {});
})();
